// extracted by mini-css-extract-plugin
export default {"tooltip":"Mo-z","sharingV2":"No-z","sharingIconsV2":"Oo-z","links":"Po-z","link":"Qo-z","facebookV2":"Ro-z","twitterV2":"So-z","pinterestV2":"To-z"};